import { useSyncExternalStore } from "react";
import { subscribe, getSnapshot, promptInstall } from "@/lib/installCapability";

export function useInstallCapability() {
  const state = useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
  return { ...state, promptInstall };
}
